import { memo } from 'react';
import { Add } from '@mui/icons-material';
import { Button } from 'components/mui/common/Button';

interface Props {
  onClick: () => void;
  text: string;
  disabled?: boolean;
  dataTestId?: string;
}

export const AddRowButton = memo(({ onClick, disabled, text, dataTestId }: Props) => {
  return (
    <Button
      variant="outlined"
      size="small"
      startIcon={<Add />}
      onClick={onClick}
      disabled={disabled}
      data-testid={dataTestId ?? 'table-add-row-button'}>
      {text}
    </Button>
  );
});
